import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DesktopAndTablet, Mobile } from '../Utils/MediaComponents/MediaComponents';
import CosmaRealEstatePreviewDesktopAndTablet from './CosmaRealEstatePreviewDesktopAndTablet';
import CosmaRealEstatePreviewMobile from './CosmaRealEstatePreviewMobile';

class CosmaRealEstatePreview extends Component {
  render() {
    return (
      <>
        <DesktopAndTablet render={() => <CosmaRealEstatePreviewDesktopAndTablet {...this.props} />} />
        <Mobile render={() => <CosmaRealEstatePreviewMobile {...this.props} />} />
      </>
    );
  }
}

CosmaRealEstatePreview.propType = {
  realEstateType: PropTypes.string.isRequired,
  currentStat: PropTypes.objectOf(
    PropTypes.shape({
      year: PropTypes.number.isRequired,
      quarter: PropTypes.number.isRequired,
      price: PropTypes.number.isRequired,
    }).isRequired,
  ).isRequired,
  priceTrend: PropTypes.objectOf(
    PropTypes.shape({
      sign: PropTypes.string.isRequired,
      priceChangeInPercent: PropTypes.number.isRequired,
      year: PropTypes.number.isRequired,
      quarter: PropTypes.number.isRequired,
    }).isRequired,
  ).isRequired,
  onClickHandler: PropTypes.func.isRequired,
  locationName: PropTypes.string.isRequired,
};

export default CosmaRealEstatePreview;
